import { render, staticRenderFns } from "./StudentStatisticsWrapper.vue?vue&type=template&id=91777b60&scoped=true"
import script from "./StudentStatisticsWrapper.vue?vue&type=script&lang=js"
export * from "./StudentStatisticsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91777b60",
  null
  
)

export default component.exports